import loadPanels from './panels'
import loadCommands from './commands';

export default (editor, opts = {}) => {
  
  loadCommands(editor, opts);
  loadPanels(editor, opts);

};